import React from "react";
import styled from "styled-components";
import { Button, Box,Grid, Stack, Link,Avatar,Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
const Footer = () => {
const theme = useTheme();

  return (
<>
<Box width="100%" height="30vh" bgcolor={theme.palette.grey[100]} padding={2}>
    <Grid container width="100%" height="100%">
      <Grid item xs={2}>
    <Stack direction="column" spacing={1} marginBottom={1}>
        <Link href="/login" sx={{color:theme.palette.black[100]}}>Login</Link>
        <Link href="/register" sx={{color:theme.palette.black[100]}}>Register</Link>
        <Link href="/" sx={{color:theme.palette.black[100]}}>About Us</Link>
        <Link href="mailto:amey.shinde@bizzencecollab.com" sx={{color:theme.palette.black[100]}}>Contact Us</Link>
    </Stack>
    <Avatar
            alt="Bizzence Logo"
            src="/images/Bizzence_demo.png"
            sx={{ width: 60, height:60, marginRight: 8 }}
          />
          </Grid>
          <Grid item xs={10}>
            <Stack direction="column"  width="100%" height="100%">
              <Box width="100%" height="50%"  sx={{ display: 'flex',justifyContent: 'center',flexDirection:'column',alignItems:'center' }}>
                  <Typography variant="h6">Connect with us on</Typography>
                  <LinkedInIcon sx={{ color: theme.palette.blue[900] }}/>
              </Box>  
              <Box width="100%" height="50%"  sx={{ display: 'flex',justifyContent: 'center',flexDirection:'column',alignItems:'center' }}>
                  <Typography variant="h5" sx={{color:theme.palette.blue[900]}}>What are you waiting for? Start scaling your business with our tools for your SMB! </Typography>
                  
              </Box> 
            </Stack>

          </Grid>
          </Grid>

</Box>
</>    
  )

}

export default Footer;